"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _GrvContext = _interopRequireDefault(require("../utils/GrvContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  autoGenerateId: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  generateId: _propTypes["default"].func,
  id: _propTypes["default"].string,
  style: _propTypes["default"].objectOf(_propTypes["default"].string)
};
var defaultProps = {
  autoGenerateId: false
};

var GrvProvider = function GrvProvider(_ref) {
  var children = _ref.children,
      autoGenerateId = _ref.autoGenerateId,
      generateId = _ref.generateId,
      className = _ref.className,
      style = _ref.style,
      id = _ref.id;
  var classes = (0, _classnames["default"])('grv-font', className);
  return /*#__PURE__*/_react["default"].createElement(_GrvContext["default"].Provider, {
    value: {
      autoGenerateId: autoGenerateId,
      generateId: generateId
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    id: id,
    style: style
  }, children));
};

GrvProvider.propTypes = propTypes;
GrvProvider.defaultProps = defaultProps;
var _default = GrvProvider;
exports["default"] = _default;